import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';
import type { Status } from '@library/types/projection';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { classNames } from '@library/utils';
import { getTooltipForStatus } from '@library/utils/status';
import { statuses } from '@library/constants/statuses';
import { useMemo } from 'react';

export const StatusSelect = ({
  boardTime = undefined,
  containerClassName = '',
  className = '',
  iconOnly = false,
  label,
  onChange,
  value,
  zIndex = undefined
}: {
  boardTime?: string;
  containerClassName?: string;
  className?: string;
  iconOnly?: boolean;
  label: string;
  onChange: (status: Status) => void;
  value: Status;
  zIndex?: number;
}) => {
  const statusValues = useMemo<SelectOption[]>(
    () =>
      statuses.map((statusType) => ({
        icon: (
          <StatusIndicator
            boardTime={boardTime}
            className={classNames(
              'self-center',
              iconOnly ? 'border-none pl-1 hover:border' : 'px-3'
            )}
            status={statusType}
          />
        ),
        key: statusType,
        name: getTooltipForStatus(statusType),
        value: statusType
      })),
    [boardTime, iconOnly]
  );

  const handleOnChange = (statusSelectOption: SelectOption) => {
    onChange(statusSelectOption.value as Status);
  };

  return (
    <Select
      containerClassName={containerClassName}
      className={className}
      iconOnly={iconOnly}
      optionsClassName="!t-6"
      label={label}
      onChange={handleOnChange}
      options={statusValues}
      size="small"
      testId="status"
      value={value}
      zIndex={zIndex}
      portal
    />
  );
};
